export enum NetAmountEnum {
    NO_DATA,
    FROM_1_TO_10,
    FROM_10_TO_50,
    FROM_50_TO_100,
    MORE_THAN_100
}
